import React from 'react';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

type Props = Omit<SvgIconProps, 'viewBox'>;

export function DownloadIcon(props: Props) {
    const newProps = {
        width: 24,
        height: 24,
        fill: 'none',
        'aria-hidden': true,
        ...props,
        viewBox: '0 0 24 24',
    };
    return React.createElement(
        SvgIcon,
        newProps,
        <path
            d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />,
        <path
            d="M12 12v9"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />,
        <path
            d="m8 17 4 4 4-4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    );
}
